import { createContext, useContext } from 'react'

export interface SsrRoutingContextValue {
  statusCode?: number
  url?: string
}

export const SsrRoutingContext = createContext<SsrRoutingContextValue | undefined>(undefined)
export const SsrRoutingContextProvider = SsrRoutingContext.Provider

export function useSsrRoutingContext() {
  return useContext(SsrRoutingContext)
}
